export const NeedToAuthEventName = 'x_need_to_auth';
